export class BillableActionError extends Error {
    constructor(message?: string) {
        super(message);
    }
}
